import React, { useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Grid,
} from "@material-ui/core";
import { Formik, Form } from "formik";
import { stores } from "mobx-store";
import { Match } from "mobx-store/stores/afconStore";
import ImageUploader from "screens/liveScoring/components/uploadLogo";
import { DateTimePicker } from "@material-ui/pickers";

interface MatchFormModalProps {
  open: boolean;
  onClose: () => void;
  match: Match | null;
}

const MatchFormModal: React.FC<MatchFormModalProps> = ({
  open,
  onClose,
  match,
}) => {
  const { afconStore } = stores;
  const isUpdate = !!match;

  const initialValues = {
    homeTeam: match?.homeTeam || "",
    awayTeam: match?.awayTeam || "",
    matchDatetime: match?.matchDatetime || "",
    homeTeamLogo: match?.homeTeamLogo || "",
    awayTeamLogo: match?.awayTeamLogo || "",
    homeGoals: match?.homeGoals ?? null,
    awayGoals: match?.awayGoals ?? null,
    homePenaltyGoals: match?.homePenaltyGoals ?? null,
    awayPenaltyGoals: match?.awayPenaltyGoals ?? null,
  };

  const handleSubmit = async (values: typeof initialValues) => {
    try {
      if (isUpdate) {
        await afconStore.updateMatch(match!.id, values as Match);
      } else {
        await afconStore.createMatch(values as Match);
      }
      onClose();
    } catch (err) {
      console.error("Error saving match", err);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{isUpdate ? "Update Match" : "Add Match"}</DialogTitle>
      <Formik initialValues={initialValues} onSubmit={handleSubmit}>
        {({ values, setFieldValue, isSubmitting }) => (
          <Form>
            <DialogContent>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <TextField
                    label="Home Team"
                    fullWidth
                    value={values.homeTeam}
                    onChange={(e) => setFieldValue("homeTeam", e.target.value)}
                  />
                  <ImageUploader
                    name="homeTeamLogo"
                    label="Home Team Logo"
                    logoUrl={values.homeTeamLogo}
                    setFieldValue={setFieldValue}
                  />
                </Grid>

                <Grid item xs={6}>
                  <TextField
                    label="Away Team"
                    fullWidth
                    value={values.awayTeam}
                    onChange={(e) => setFieldValue("awayTeam", e.target.value)}
                  />
                  <ImageUploader
                    name="awayTeamLogo"
                    label="Away Team Logo"
                    logoUrl={values.awayTeamLogo}
                    setFieldValue={setFieldValue}
                  />
                </Grid>

                <Grid item xs={12}>
                  {/* <TextField
                    label="Match Date & Time"
                    type="datetime-local"
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    value={values.matchDatetime}
                    onChange={(e) =>
                      setFieldValue("matchDatetime", e.target.value)
                    }
                  /> */}
                  <DateTimePicker
                    label="Start Date and Time"
                    value={values.matchDatetime}
                    onChange={(newValue) => {
                      setFieldValue('matchDatetime', newValue);
                    }}
                    fullWidth
                    margin="normal"
                    // This library automatically renders a TextField, so you don't need a separate renderInput prop.
                    // If you need custom props for the TextField, you pass them directly to DateTimePicker.
                    inputProps={{
                      name: "matchDatetime"
                    }}
                  />

                </Grid>

                {isUpdate && (
                  <>
                    <Grid item xs={6}>
                      <TextField
                        label="Home Goals"
                        type="number"
                        fullWidth
                        value={values.homeGoals ?? ""}
                        onChange={(e) =>
                          setFieldValue("homeGoals", Number(e.target.value))
                        }
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        label="Away Goals"
                        type="number"
                        fullWidth
                        value={values.awayGoals ?? ""}
                        onChange={(e) =>
                          setFieldValue("awayGoals", Number(e.target.value))
                        }
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        label="Home Penalty Goals"
                        type="number"
                        fullWidth
                        value={values.homePenaltyGoals ?? ""}
                        onChange={(e) =>
                          setFieldValue(
                            "homePenaltyGoals",
                            Number(e.target.value)
                          )
                        }
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        label="Away Penalty Goals"
                        type="number"
                        fullWidth
                        value={values.awayPenaltyGoals ?? ""}
                        onChange={(e) =>
                          setFieldValue(
                            "awayPenaltyGoals",
                            Number(e.target.value)
                          )
                        }
                      />
                    </Grid>
                  </>
                )}
              </Grid>
            </DialogContent>

            <DialogActions>
              <Button onClick={onClose}>Cancel</Button>
              <Button type="submit" color="primary" variant="contained">
                {isSubmitting ? 'Saving...' : 'Save'}
              </Button>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default MatchFormModal;
